module.exports = __webpack_public_path__ + "static/media/Werewolf.0673a6db.png";